import * as React from 'react'
import {Redirect, RouteComponentProps} from 'react-router'

interface IProps extends RouteComponentProps<void> {
  redirectToReferrer: boolean
  routeBlacklist?: string[]
  defaultRoute: string
  from: (state: any) => {pathname: string}
  children?: any
}

export class RedirectToReferrer extends React.PureComponent<IProps, {}> {
  public render() {
    const {from, redirectToReferrer, routeBlacklist = [], location, defaultRoute} = this.props

    if (redirectToReferrer) {
      const referrer = location.state && from(location.state)
      if (!referrer || routeBlacklist.find((blackRoute) => referrer.pathname === blackRoute)) {
        return <Redirect to={defaultRoute} />
      }
      return <Redirect to={referrer} />
    }
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/PrivateRoute/RedirectToReferrer.tsx